import { BaseStore } from 'fluxible/addons';
import Actions from '../constants/Actions';

class AnalyticsStore extends BaseStore {

  static storeName = 'AnalyticsStore';

  static handlers = {
    [Actions.SIDEBAR_TOGGLE_CLICKED]:'handleSidebarToggle'
  };

  constructor(dispatcher) {
    super(dispatcher);
    this.sidebarActive = true;
  }

  handleSidebarToggle() {
    this.sidebarActive = !this.sidebarActive;
    this.emitChange();
  }

  isSidebarActive() {
    return this.sidebarActive;
  }

  dehydrate() {
    return {
      sidebarActive: this.sidebarActive
    };
  }

  rehydrate(state) {
    this.sidebarActive = state.sidebarActive;
  }
}

export default AnalyticsStore;



// WEBPACK FOOTER //
// ./src/stores/AnalyticsStore.js